import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDown, ArrowRight } from 'lucide-react';
export function MechanismReveal() {
  return <section className="py-24 px-6 bg-[#14142B] relative overflow-hidden" data-id="element-101">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#D4A574] opacity-5 blur-[120px] rounded-full pointer-events-none" data-id="element-102" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-104">
          <span className="text-[#D4A574] font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-105">
            El Mecanismo Único
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-106">
            La Escalera de Cierre
          </h2>
          <p className="text-xl text-[#F5F0E8]/80 max-w-2xl mx-auto" data-id="element-107">
            En vez de intentar pasar de "me quedo hasta que se duerma" a "me voy
            y listo"… hacemos un puente medible.
          </p>
        </motion.div>

        {/* The Steps Visualization */}
        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-108">
          {[{
          nights: 'Noches 1–2',
          time: '12 minutos',
          desc: 'Contención inicial con límite claro'
        }, {
          nights: 'Noches 3–4',
          time: '6 minutos',
          desc: 'Reducción gradual del apoyo'
        }, {
          nights: 'Noches 5–7',
          time: '3 minutos',
          desc: 'Cierre breve y despedida'
        }].map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="relative group" data-id="element-109">
              <div className="bg-[#1C1C2E] p-8 rounded-2xl border border-[#D4A574]/20 h-full flex flex-col items-center text-center hover:bg-[#1C1C2E]/80 transition-all hover:-translate-y-1 shadow-lg" data-id="element-110">
                <div className="w-16 h-16 rounded-full bg-[#D4A574]/10 flex items-center justify-center mb-4 group-hover:bg-[#D4A574]/20 transition-colors" data-id="element-111">
                  <TrendingDown className="w-8 h-8 text-[#D4A574]" data-id="element-112" />
                </div>
                <h3 className="text-[#D4A574] font-bold mb-2" data-id="element-113">{step.nights}</h3>
                <div className="text-4xl font-serif font-bold text-white mb-4" data-id="element-114">
                  {step.time}
                </div>
                <p className="text-[#F5F0E8]/60 text-sm" data-id="element-115">{step.desc}</p>
              </div>

              {/* Connector Arrow (Desktop only) */}
              {i < 2 && <div className="hidden md:block absolute top-1/2 -right-3 -translate-y-1/2 z-20 text-[#D4A574]/30" data-id="element-116">
                  <ArrowRight size={24} data-id="element-117" />
                </div>}
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-[#1C1C2E] p-8 rounded-2xl border border-[#5A8A7A]/20 text-center max-w-2xl mx-auto" data-id="element-118">
          <p className="text-lg text-[#F5F0E8]/90" data-id="element-119">
            Con un cierre corto, repetible, y{' '}
            <span className="text-[#D4A574] font-semibold" data-id="element-120">
              sin inventar rituales nuevos
            </span>
            .
            <br data-id="element-121" />
            Solo cortamos lo que sobra.
          </p>
        </motion.div>
      </div>
    </section>;
}